import axios from "axios";
import { APP_URL } from "../../config/api";
import { errorMessage } from "../errorHandle";

export const getUserAllList = () => {
  return (dispatch) => {
    dispatch({
      type: USERPROFILE.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-all-lp-users`,
      })
      .then((res) => {
        dispatch({
          type: USERPROFILE.GET_ALL_USER_LISR,
          payload: res.data.list,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, USERPROFILE.ERROR));
      });
  };
};

export const getUserProfile = (parm) => {
  return (dispatch) => {
    dispatch({
      type: USERPROFILE.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-user-details`,
        data: parm,
      })
      .then((res) => {
        dispatch({
          type: USERPROFILE.GET_USER,
          payload: res.data.list,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, USERPROFILE.ERROR));
      });
  };
};

export const updateUserProfile = (parm) => {
  return (dispatch) => {
    dispatch({
      type: USERPROFILE.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/update-user-profile`,
        data: parm,
      })
      .then((res) => {
        dispatch({
          type: USERPROFILE.UPDATE_USER_PROFILE,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, USERPROFILE.ERROR));
      });
  };
};

export const downloadCertificateAccess = (parm) => {
  return (dispatch) => {
    dispatch({
      type: USERPROFILE.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/lpu/download-certificate-access`,
        data: parm,
      })
      .then((res) => {
        dispatch({
          type: USERPROFILE.DOWNLOAD_CERTIFICATE_ACCESS,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, USERPROFILE.ERROR));
      });
  };
};



const TAG = "UP";

export const USERPROFILE = {
  ERROR: TAG + "ERROR",
  REQUEST: TAG + "REQUEST",
  GET_ALL_USER_LISR: TAG + "GET_ALL_USER_LISR",
  GET_USER: TAG + "GET_USER",
  UPDATE_USER_PROFILE: TAG + "UPDATE_USER_PROFILE",
  DOWNLOAD_CERTIFICATE_ACCESS: TAG + "DOWNLOAD_CERTIFICATE_ACCESS",
  SEND_CERTIFICATE_ON_EMAIL: TAG + "SEND_CERTIFICATE_ON_EMAIL",
};
